import { SIZE_SCALE, PADDING_X, PADDING_Y, TYPE_SCALE } from '@/components/design-system/tokens';

export const PAGINATION_NUMBER_BUTTON = `${SIZE_SCALE['10']} ${SIZE_SCALE.w10} ${SIZE_SCALE.minW40} ${PADDING_X['0']} ${PADDING_Y['0']} ${TYPE_SCALE.sm}`;

export const PAGINATION_ICON_BUTTON = `${SIZE_SCALE['10']} ${SIZE_SCALE.w10} ${SIZE_SCALE.minW40} ${PADDING_X['0']} ${TYPE_SCALE.sm}`;

export const PAGINATION_CONTROL_BUTTON = `${SIZE_SCALE['10']} ${SIZE_SCALE.minW52} ${PADDING_X['4']} ${TYPE_SCALE.sm}`;

export const PAGINATION_COMPACT_BUTTON = `${SIZE_SCALE['10']} ${SIZE_SCALE.minW44} px-3 ${TYPE_SCALE.sm}`;
